import { Pipe, PipeTransform } from '@angular/core';
import chroma from 'chroma-js';
import { findIndex } from 'lodash';
@Pipe({
    name: 'locationHeatmapColor',
})
export class LocationHeatmapColorPipe implements PipeTransform {
    transform(powerKwh: number, arg1: number[]): string {
        // Remove duplicates and sort array
        let powers = [...new Set(arg1)];
        powers = powers.sort((a, b) => a - b);

        // Create color scale based on the length of unique powers list
        const colorScale = chroma.scale(['#65ff65', '#00d300']).colors(powers.length);
        const color = colorScale[findIndex(powers, (e) => e === powerKwh) ?? 0];

        return color;
    }
}
